import { useEffect, useState } from "react";
import { Modal, Typography, Skeleton } from "antd";

const { Paragraph, Link } = Typography;

function FormSkeleton() {
  return (
    <div style={{ padding: "4px 0" }}>
      {[1, 2, 3].map((i) => (
        <div key={i} style={{ marginBottom: 20 }}>
          <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8, display: "block" }} />
          <Skeleton.Input active style={{ width: "100%", height: 40 }} block />
        </div>
      ))}
      <Skeleton.Button active style={{ width: 120, height: 40, marginTop: 4 }} />
    </div>
  );
}

export default function RequestAccessModal({
  visible,
  onCancel,
  accessType,
  deliverableName,
}) {
  const [formLoaded, setFormLoaded] = useState(false);

  useEffect(() => {
    if (!visible) {
      setFormLoaded(false);
      return;
    }

    const createForm = () => {
      const target = document.getElementById("hubspotForm");
      if (!target) return;

      target.innerHTML = "";

      const existingForms = document.querySelectorAll("[data-hubspot-form-id]");
      existingForms.forEach((form) => form.remove());

      if (window.hbspt) {
        try {
          window.hbspt.forms.create({
            portalId: "24251729",
            formId: "e861b68d-eb5d-47f3-9263-59f0aab798b3",
            region: "na1",
            target: "#hubspotForm",
            onFormReady: () => setFormLoaded(true),
          });
        } catch (error) {
          console.error("HubSpot form creation error:", error);
        }
      }
    };

    if (window.hbspt) {
      createForm();
    } else {
      let script = document.querySelector('script[src*="js.hsforms.net"]');

      if (!script) {
        script = document.createElement("script");
        script.src = "https://js.hsforms.net/forms/embed/v2.js";
        script.charset = "utf-8";
        script.type = "text/javascript";
        document.body.appendChild(script);
      }

      script.addEventListener("load", () => {
        setTimeout(createForm, 100);
      });
    }
  }, [visible]);

  return (
    <Modal
      title="Trust Center Access Request"
      open={visible}
      onCancel={onCancel}
      footer={null}
      getContainer={false}
      mask={true}
      maskClosable={true}
      width={600}
    >
      <div style={{ marginTop: "24px" }}>
        {!formLoaded && <FormSkeleton />}
        <div id="hubspotForm" style={{ display: formLoaded ? "block" : "none" }}></div>

        <Paragraph
          style={{
            color: "#666",
            fontSize: "14px",
            marginTop: "12px",
            textAlign: "center",
          }}
        >
          Already have access?{" "}
          <Link
            href="https://app.paramify.com"
            style={{ color: "#1467FF" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Login
          </Link>
        </Paragraph>
      </div>
    </Modal>
  );
}
